import React from 'react';
import { Outlet } from 'react-router';
import { Link, NavLink } from 'react-router-dom';
import { useUserContext } from '../../shared/user-context';
import Loader from '../../ui/Loader';

const Layout: React.FC<{ children?: React.ReactNode }> = (props) => {
    const { isUserLoggedIn } = useUserContext();
    const isLoggedIn = isUserLoggedIn();

    return (
        <div className="container">
            <nav className="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
                <div className="container">
                    <Link to={"/"} className="navbar-brand">O2 Logs</Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <NavLink to={`/`} className={({ isActive, isPending }) => isActive ? "nav-link link-info active" : isPending ? "nav-link pending" : "nav-link link-light"}>Home</NavLink>
                            </li>
                            {isLoggedIn &&
                                (
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="/portal/log/" id="portalpartner" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Partner Portal Logs
                                        </a>
                                        <ul className="dropdown-menu" aria-labelledby="portalpartner">
                                            <li className="dropdown-item">
                                                <NavLink to={`/portal/log/list`} className={({ isActive, isPending }) => isActive ? "link-info active" : isPending ? "pending" : "link-dark"}>Logs</NavLink>
                                            </li>
                                            <li className="dropdown-item">
                                                <NavLink to={`/portal/log/ignore-keyword/list`} className={({ isActive, isPending }) => isActive ? "link-info active" : isPending ? "pending" : "link-dark"}>Log Ignores</NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                )
                            }
                            {isLoggedIn &&
                                (
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="/ms/log/" id="microsites" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Microstes Logs
                                        </a>
                                        <ul className="dropdown-menu" aria-labelledby="microsites">
                                            <li className="dropdown-item">
                                                <NavLink to={`/ms/log/list`} className={({ isActive, isPending }) => isActive ? "link-info active" : isPending ? "pending" : "link-dark"}>Logs</NavLink>
                                            </li>
                                            <li className="dropdown-item">
                                                <NavLink to={`/ms/log/ignore-keyword/list`} className={({ isActive, isPending }) => isActive ? "link-info active" : isPending ? "pending" : "link-dark"}>Log Ignores</NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                )
                            }
                            {/* {
                                isLoggedIn && (
                                    <li className="nav-item">
                                        <NavLink to={`/portal/log/ignore-keyword/add`} className={({ isActive, isPending }) => isActive ? "nav-link link-info active" : isPending ? "nav-link pending" : "nav-link link-light"}>New Request</NavLink>
                                    </li>
                                )
                            } */}
                            {/*<li className="nav-item">*/}
                            {/*    <NavLink to={`/new-request`} className={({ isActive, isPending }) => isActive ? "nav-link link-info active" : isPending ? "nav-link pending" : "nav-link link-light"}>New Request</NavLink>*/}
                            {/*</li>*/}
                        </ul>

                        <ul className="nav justify-content-end text-white">
                            {
                                !isLoggedIn && <li className="nav-item">
                                    <NavLink to={`/login`} className={({ isActive, isPending }) => isActive ? "nav-link link-light text-info active" : isPending ? "nav-link link-light pending" : "nav-link link-light"}>Login</NavLink>
                                </li>
                            }
                            {
                                isLoggedIn && <li className="nav-item">
                                    <Link to={"/logout"} className="nav-link link-light text-info">Logout</Link>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </nav>
            <div className="" style={{ marginTop: '74px', marginBottom: '30px' }}>
                <React.Suspense fallback={<Loader />}>
                    {props.children}
                    <Outlet />
                </React.Suspense>
            </div>
        </div>
    );
}

export default Layout;